import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import CashLoanLayer from "../../../components/Admin/CashLoanLayer";

const CashLoan = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <CashLoanLayer />
      </MasterLayout>
    </>
  );
};

export default CashLoan;